export default __webpack_public_path__ + "images/MF.53a1d68.png";